import React, { useState } from "react";
import OverviewTab from "../components/marketing/OverviewTab";
import StrategyTab from "../components/marketing/StrategyTab";
import BlogTab from "../components/marketing/BlogTab";
import SocialTab from "../components/marketing/SocialTab";
import ChatsTab from "../components/marketing/ChatsTab";
import EmailsTab from "../components/marketing/EmailsTab";

const TABS = [
  ["overview", "Overview", OverviewTab],
  ["strategy", "30-Day Strategy", StrategyTab],
  ["blog", "SEO Blog", BlogTab],
  ["social", "Social Posts", SocialTab],
  ["chats", "Chat Leads", ChatsTab],
  ["emails", "Email Log", EmailsTab],
];

export default function Marketing() {
  const [tab, setTab] = useState("overview");
  const Active = TABS.find((t) => t[0] === tab)[2];

  return (
    <div className="p-6 lg:p-10 max-w-7xl" data-testid="marketing-page">
      <div className="text-xs uppercase tracking-[0.2em] font-bold text-slate-500">Admin · Growth</div>
      <h1 className="font-display text-4xl font-bold tracking-tight text-slate-950 mt-1">AI Marketing Engine</h1>
      <p className="text-slate-600 mt-2 max-w-2xl">
        Your autonomous sales team: Max the chatbot, lifecycle emails, SEO content and social copy — all in one place.
      </p>
      <div className="mt-8 flex flex-wrap gap-1 border-b border-slate-200">
        {TABS.map(([k, label]) => (
          <button
            key={k}
            onClick={() => setTab(k)}
            data-testid={`marketing-tab-${k}`}
            className={`px-4 py-2.5 text-sm font-semibold -mb-px border-b-2 transition-colors ${
              tab === k ? "border-orange-600 text-orange-600" : "border-transparent text-slate-600 hover:text-slate-900"
            }`}
          >
            {label}
          </button>
        ))}
      </div>
      <div className="mt-8">
        <Active />
      </div>
    </div>
  );
}
